const useStyles = theme => ({
  carouselContainer: {
    paddingLeft: 10,
    paddingRight: 10,
  },
  titlesContainer: {
    paddingTop: 15,
    height: 170,
    cursor: 'pointer',
    [theme.breakpoints.only('md')]: {
      paddingTop: 20,
      height: 165,
    }
  },
  mainTitle: {
    display: "-webkit-box",
    boxOrient: "vertical",
    lineClamp: 2,
    wordBreak: "break-word",
    overflow: "hidden",
  },
  secondaryTitle: {
    display: "-webkit-box",
    boxOrient: "vertical",
    lineClamp: 1,
    wordBreak: "break-word",
    overflow: "hidden",
    marginTop: 15,
    [theme.breakpoints.only('md')]: {
      lineClamp: 2,
    }
  },
  arrowIconContainer: {
    position: 'absolute',
    zIndex: 2,
  },
});

export default useStyles
